const GridIcon = ({ className }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      style={{marginRight:10}}
      className={className}
    >
      <path
        d="M4.16667 15.8333V17.5C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333H4.16667ZM2.5 14.1667V12.5H4.16667V14.1667H2.5ZM2.5 10.8333V9.16667H4.16667V10.8333H2.5ZM2.5 7.5V5.83333H4.16667V7.5H2.5ZM4.16667 4.16667H2.5C2.5 3.70833 2.66319 3.31597 2.98958 2.98958C3.31597 2.66319 3.70833 2.5 4.16667 2.5V4.16667ZM5.83333 17.5V15.8333H7.5V17.5H5.83333ZM5.83333 4.16667V2.5H7.5V4.16667H5.83333ZM9.16667 17.5V15.8333H10.8333V17.5H9.16667ZM9.16667 4.16667V2.5H10.8333V4.16667H9.16667ZM12.5 17.5V15.8333H14.1667V17.5H12.5ZM12.5 4.16667V2.5H14.1667V4.16667H12.5ZM15.8333 15.8333H17.5C17.5 16.2917 17.3368 16.684 17.0104 17.0104C16.684 17.3368 16.2917 17.5 15.8333 17.5V15.8333ZM15.8333 14.1667V12.5H17.5V14.1667H15.8333ZM15.8333 10.8333V9.16667H17.5V10.8333H15.8333ZM15.8333 7.5V5.83333H17.5V7.5H15.8333ZM15.8333 4.16667V2.5C16.2917 2.5 16.684 2.66319 17.0104 2.98958C17.3368 3.31597 17.5 3.70833 17.5 4.16667H15.8333Z"
        fill="currentColor"
      />
    </svg>
  );
  
  export default GridIcon;
  